import { Mapper, MapperParams } from './type.mapper';
import { MapperFactory } from './mapper-factory';
import { ExchangeRateDTO } from '../../types/dto/exchange-rate.dto.type';
import { ExchangeRate } from '../../types/exchange-rate.type';

export class ExchangeRateSetMapper extends Mapper<ExchangeRate[]> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(exchangeRateSetDTO: ExchangeRateDTO[]): ExchangeRate[] {
    const exchangeRateSet: ExchangeRate[] = [];

    exchangeRateSetDTO.forEach((exchangeRateDto: ExchangeRateDTO) => {
      const exchangeRate: ExchangeRate = this.createMapper(
        ExchangeRateMapper
      ).toDomain(exchangeRateDto);

      if (exchangeRate) {
        exchangeRateSet.push(exchangeRate);
      }
    });

    return exchangeRateSet;
  }
}

export class ExchangeRateMapper extends Mapper<ExchangeRate> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(exchangeRateDto: ExchangeRateDTO): ExchangeRate {
    return {
      asOfDate: exchangeRateDto.asofdate,
      asOfDateStd: exchangeRateDto.asofdatestd,
      exchangeMultiplier: exchangeRateDto.exchmultiplier,
      exchangeMultiplierStd: exchangeRateDto.exchmultiplierstd,
      sourceCurrency: exchangeRateDto.sourcecurr,
      targetCurrency: exchangeRateDto.targetcurr,
    };
  }
}
